import React from "react";
import { Tabs } from "antd";
import AccountDetail from "./AccountDetail";
import Payment from "./Payment";
import History from "./History";

const { TabPane } = Tabs;

const Profile = props => {
  return (
    <div style={{ marginTop: 40 }}>
      <h2>Account Details</h2>
      <Tabs style={{ marginTop: 40 }} defaultActiveKey="1">
        <TabPane tab="Account" key="1">
          <AccountDetail {...props} />
        </TabPane>
        <TabPane tab="Payment" key="2">
          <Payment
            onClickPlan={props.onClickPlan}
            state={props.state}
            subscription={props.subscription}
            cancelSubscription={props.cancelSubscription}
            onChangePlan={props.onChangePlan}
          />
        </TabPane>
        <TabPane tab="History" key="3">
          <History />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Profile;
